module.exports = __webpack_public_path__ + "img/e19a2ed.jpg";